export const zeroDecimals = '0.00';
